<template>
  <mapbox
    :access-token="mapboxKey"
    :map-options="mapOptions"
    :geolocate-control="{
      show: true,
      position: 'top-left'
    }">
  </mapbox>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';

export default {
  name: 'eat-map',
  components: { Mapbox },
  data: function() {
    return {
      mapOptions: {
        style: 'mapbox://styles/mapbox/light-v9',
        center: [-96, 37.8],
        zoom: 3
      },
      mapboxKey: process.env.VUE_APP_MAPBOX_KEY
    }
  }
}
</script>

<style scoped>

</style>
